/* eslint-disable @next/next/no-img-element */
import { CMSModal } from "@/context";
import Modal from "@/designs/Modal";
import { DeliveryEnum, DeliveryType } from "@/graphql/generated/schema";

import React, { useContext } from "react";
import RecipientDelivery from "./RecipientDelivery";
import GeneralDelivery from "./GeneralDelivery";
import VerticalNavigator from "@/designs/VerticalNavigator";
interface ViewDeliveryProps {
  isOpen: boolean;
  onClose: () => void;
  delivery: DeliveryType | null;
  allDeliveries: DeliveryType[] | any;
  setDelivery: (delivery: DeliveryType) => void;
}
const ViewDelivery = ({
  isOpen,
  onClose,
  delivery,
  allDeliveries,
  setDelivery,
}: ViewDeliveryProps) => {
  const { theme } = useContext(CMSModal);
  const currentIndex = allDeliveries?.findIndex(
    (v: DeliveryType) => v.id === delivery?.id,
  );
  const handleMove = (direction: "up" | "down") => {
    if (!Array.isArray(allDeliveries)) return;

    let newIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;

    if (newIndex < 0 || newIndex >= allDeliveries.length) return; // out of bounds

    const nextVisitor = allDeliveries[newIndex];
    if (nextVisitor) setDelivery(nextVisitor);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <VerticalNavigator
        currentIndex={currentIndex}
        total={allDeliveries.length}
        onMoveUp={() => handleMove("up")}
        onMoveDown={() => handleMove("down")}
        theme={theme}
      />


      {
        delivery?.deliveryType === DeliveryEnum.Recipient ? (
          <RecipientDelivery delivery={delivery} onClose={onClose}/>
        ) : (
          <GeneralDelivery delivery={delivery} onClose={onClose}/>
        )
      }
    </Modal >
  );
};

export default ViewDelivery;
